// index.js
'use strict';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './component/App.jsx';

ReactDOM.render(<App />, document.getElementById('app-root'));
